import { createContext } from "react";
import { ContextProperties } from "./types";

export const AuthContext = createContext<ContextProperties>({
  accessToken: undefined,
  isFetching: false,
  login: () => {},
  logout: () => {}
});
